// Mock data for Simply Gold Productions facelift.
// FRONTEND-ONLY mock — contact form submissions are stored in localStorage.

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Brand Stories', href: '#brand-stories' },
  { label: 'Trades', href: '#trades' },
  { label: 'Pro Sports', href: '#pro-sports' },
  { label: 'Documentary', href: '#documentaries' },
  { label: 'FAQ', href: '#faq' },
  { label: 'About', href: '#about' },
];

export const tradesPage = {
  banner: {
    title: "Learn How Simply Gold Productions Can Elevate Your Construction & Trades Business Using Video",
    youtubeId: 'GruVnjEqZVg',
    thumb: 'https://i.ytimg.com/vi/GruVnjEqZVg/maxresdefault.jpg',
  },
  videos: [
    { id: 'core', title: "Core Mechanical | Raising the Standard in Mechanical Construction", client: 'Core Mechanical', youtubeId: '_apQxYZf32c' },
    { id: 'whyte', title: "COME WORK WITH WHYTE MECHANICAL", client: 'Whyte Mechanical', youtubeId: 'O6yKOlnSxyY' },
    { id: 'limitless', title: "Limitless AV: Communication Simplified", client: 'Limitless AV', youtubeId: 'fr8Xo1XYuDE' },
    { id: 'janks-profile', title: "JANKS DESIGN GROUP BUSINESS PROFILE", client: 'Janks Design Group', youtubeId: 'YM2PViO7sHk' },
    { id: 'janks-tapbarrel', title: "JDG & Prodigy - Building The New Brentwood Tap & Barrel [Case Study]", client: 'Janks Design Group', youtubeId: 'aiACPXpmaEo' },
    { id: 'enviroware', title: "Enviroware Projects HVAC Install Highlight Video", client: 'Enviroware Projects', youtubeId: 'HNIdzecfEJI' },
    { id: 'greenpark-homeshow', title: "Behind the Build with Green Park Landscaping: Kelowna Home Show 2026", client: 'Green Park Landscaping', youtubeId: '-sZVPVQ_pI4' },
    { id: 'greenpark-xeriscape', title: "How Greenpark Landscaping Transformed Rod's Garden with their Xeriscape Design", client: 'Green Park Landscaping', youtubeId: 'BpTjpVK1iZc' },
    { id: 'greenpark-sonoma', title: "How GreenPark Landscaping Transformed Sonoma Pines with a 400 Foot Rock Wall", client: 'Green Park Landscaping', youtubeId: '52xqldd-uUs' },
    { id: 'eviston-paul', title: "He Found Us a Home That Wasn't Even Listed And Talked Us Into Paying LESS | Paul Eviston Review", client: 'Team Eviston Real Estate', youtubeId: 'aHozsDK-vF0' },
    { id: 'eviston-david', title: "Team Eviston - Testimonial David & Melissa", client: 'Team Eviston Real Estate', youtubeId: 'o1192YNJY5Q' },
    { id: 'gasguys', title: "THE GAS GUYS | PRODUCT VIDEO", client: 'The Gas Guys', youtubeId: 'fvd8-YHjkY4' },
  ],
};

export const packages = [
  {
    id: 'gold',
    name: 'Gold',
    featured: true,
    features: [
      { text: '3 x 8 hour shooting days, interview & b-roll', included: true },
      { text: '1 day of drone with licensed operator', included: true },
      { text: '3 mins Business profile with interview, b-roll & music', included: true },
      { text: '60 sec social videos (3 videos)', included: true },
      { text: '30 sec client testimonial (2 testimonials)', included: true },
      { text: '2 business headshot photos', included: true },
      { text: '30 photos for social media', included: true },
      { text: '2 rounds of revisions', included: true },
      { text: 'SRT caption file', included: true },
    ],
  },
  {
    id: 'silver',
    name: 'Silver',
    featured: false,
    features: [
      { text: '2 x 8 hour shooting days, interview & b-roll', included: true },
      { text: '1 day of drone with licensed operator', included: true },
      { text: '3 mins Business profile with interview, b-roll & music', included: true },
      { text: '60 sec social videos (1 video)', included: true },
      { text: '30 sec client testimonial (1 testimonial)', included: false },
      { text: '20 photos for social media', included: true },
      { text: '2 rounds of revisions', included: true },
      { text: 'SRT caption file', included: true },
      { text: '2 business headshot photos', included: false },
    ],
  },
  {
    id: 'bronze',
    name: 'Bronze',
    featured: false,
    features: [
      { text: '2 x 8 hour shooting days, interview & b-roll', included: true },
      { text: '2 mins Business profile with interview, b-roll & music', included: true },
      { text: '10 photos for social media', included: true },
      { text: '2 rounds of revisions', included: true },
      { text: 'SRT caption file', included: true },
      { text: '2 business headshot photos', included: false },
      { text: '30 sec client testimonial (1 testimonial)', included: false },
      { text: '60 sec social videos (3 videos)', included: false },
      { text: '1 day of drone with licensed operator', included: false },
    ],
  },
];

// Real Simply Gold Productions YouTube videos.
export const showreel = {
  title: "SIMPLY GOLD PRODUCTIONS 2023 COMPANY REEL",
  youtubeId: 'L55nH_f3tDc',
};

// Muted, looping background reel for the hero (Simply Gold Company Reel).
export const bgVideoId = 'L55nH_f3tDc';

// Single "What Clients Are Saying" mashup video (replaces the old carousel).
export const clientVideo = {
  title: "Why Choose Simply Gold Productions - Video Testimonial",
  youtubeId: '0SGyqV9d5bs',
  thumb: 'https://i.ytimg.com/vi/0SGyqV9d5bs/maxresdefault.jpg',
};

// Drone / aerial page content.
export const droneShowcase = {
  reel: {
    title: "SIMPLY GOLD PRODUCTIONS DRONE REEL",
    youtubeId: 'E-LkOdtAcdU',
    thumb: 'https://i.ytimg.com/vi/E-LkOdtAcdU/maxresdefault.jpg',
  },
  clips: [
    {
      id: 'kelowna-fire',
      title: 'Aftermath of the 2023 Kelowna Wildfire',
      youtubeId: 'ZGyszioRqY4',
      thumb: 'https://i.ytimg.com/vi/ZGyszioRqY4/maxresdefault.jpg',
    },
  ],
};

export const droneBlurb =
  'Licensed and insured drone operators bringing a whole new perspective to your story. From sweeping establishing shots and cinematic reveals to real estate, construction progress and large-scale events, our aerial team captures the scale and detail that ground-level cameras simply can\u2019t. Every flight is planned, compliant and built to make your project look its absolute best from above.';

export const trustedLogos = [
  { name: 'Louis T. Picco Inc. — Chartered Professional Accountant', src: '/logos/picco.png', category: 'Brand Story' },
  { name: 'The Gas Guys Outdoor Designs', src: '/logos/gasguys.png', category: 'Trades' },
  { name: 'Kinship Kollective', src: '/logos/kinship.png', category: 'Brand Story' },
  { name: 'Guy Felicella', src: '/logos/felicella.png', category: 'Documentary' },
  { name: 'InvestX — Private Equity Marketplace', src: '/logos/investx.png', category: 'Brand Story' },
  { name: 'Trevor Crean', src: '/logos/trevorcrean.png', category: 'Documentary' },
  { name: 'Heritage Gardens — A Sustainable Cemetery', src: '/logos/heritage.png', category: 'Documentary' },
  { name: 'Little Devils Wood Fire Pizza', src: '/logos/littledevils.png', category: 'Brand Story' },
  { name: 'Enviroware Projects', src: '/logos/enviroware.png', category: 'Aerial' },
  { name: 'Eviston Real Estate', src: '/logos/eviston.png', category: 'Brand Story' },
  { name: 'Whisky Wiseman', src: '/logos/whiskywiseman.png', category: 'Brand Story' },
  { name: 'Vancouver College', src: '/logos/vancouvercollege.png', category: 'Brand Story' },
  { name: 'JDG Interior Design +', src: '/logos/jdg.png', category: 'Brand Story' },
  { name: 'IG Wealth Management', src: '/logos/igwealth.png', category: 'Brand Story' },
  { name: 'Vancouver Canucks', src: '/logos/canucks.png', category: 'Brand Story' },
  { name: 'Vancouver Warriors', src: '/logos/wwshield.png', category: 'Brand Story' },
  { name: 'Vancouver Canadians', src: '/logos/vancouvercanadians.png', category: 'Brand Story' },
  { name: 'Vancouver Titans', src: '/logos/sasquatch.png', category: 'Documentary' },
  { name: 'The Coaches Site', src: '/logos/coachessite.png', category: 'Brand Story' },
  { name: 'Cool Tugs', src: '/logos/pawlogo.png', category: 'Brand Story' },
  { name: 'Whyte Mechanical', src: '/logos/whyte.png', category: 'Trades' },
  { name: 'Limitless Audio Visual Integration', src: '/logos/limitless.png', category: 'Trades' },
  { name: 'Core Mechanical', src: '/logos/coremech.png', category: 'Aerial' },
  { name: 'Greenpark Landscaping', src: '/logos/greenpark.png', category: 'Aerial' },
  { name: 'PRP', src: '/logos/prp.png', category: 'Brand Story' },
  { name: "Johnny's Heart of Gold", src: '/logos/johnnysheartofgold.png', category: 'Brand Story' },
  { name: 'Synscape', src: '/logos/synscape.png', category: 'Trades' },
  { name: 'Wax Pencil Imagery', src: '/logos/waxpencil.png', category: 'Brand Story' },
  { name: 'Smashed Potato Kids', src: '/logos/smashedpotatokids.png', category: 'Brand Story' },
  { name: 'Ronda Hymers', src: '/logos/rondahymers.png', category: 'Brand Story' },
];

export const services = [
  {
    id: 'commercial',
    title: 'Commercial Video',
    tagline: 'Adapting to your business, whatever the size or industry.',
    desc: 'Brand films, product spots and testimonial pieces engineered to convert. From script to final cut, we craft the story that drives your business forward.',
    image: '/media/commercial.jpg',
    youtubeId: 'AQXonFtlsPg',
  },
  {
    id: 'sports',
    title: 'Sports Videography',
    tagline: 'Innovation and captivating storytelling for every play.',
    desc: 'Every pivotal moment, every thrilling goal, captured with precision. Built for professional leagues, aspiring athletes and sports brands alike.',
    image: '/media/sports.jpg',
    youtubeId: 'AZOHmz0uQ0I',
  },
  {
    id: 'documentary',
    title: 'Documentary',
    tagline: 'Powerful stories that seek change and create impact.',
    desc: 'Human-first storytelling that moves audiences. We find the truth in your story and shape it into something unforgettable.',
    image: '/media/documentary.webp',
    youtubeId: 'TIaB5xV0VPM',
  },
  {
    id: 'trades',
    title: 'Trades & Construction',
    tagline: 'Build trust, win jobs and grow your trades brand.',
    desc: 'Real crews, real job sites, real results. We show your quality and process in action — the edge that wins bigger contracts in the trades and construction.',
    image: '/media/trades.webp',
    youtubeId: 'GruVnjEqZVg',
  },
];

// Homepage Brand Stories features these 6; the rest live on the /brand-stories page.
export const brandStoriesFeaturedIds = ['tapbarrel', 'canucks', 'core', 'greycup', 'limitless'];

export const recentWork = [
  {
    id: 'tapbarrel',
    title: "JDG & Prodigy - Building The New Brentwood Tap & Barrel [Case Study]",
    client: 'JDG & Prodigy',
    category: 'Commercial',
    thumb: '/media/tapbarrel.webp',
    youtubeId: 'aiACPXpmaEo',
  },
  {
    id: 'canucks',
    title: "Behind the Scenes | Canucks Mission Home",
    client: 'Vancouver Canucks',
    category: 'Sports',
    thumb: '/media/canucks.jpg',
    youtubeId: 'nXMHSyf0H2E',
  },
  {
    id: 'greycup',
    title: "Behind the Scenes of how PRP put on the 111th Grey Cup Halftime Show",
    client: 'PRP',
    category: 'Documentary',
    thumb: '/media/greycup.jpg',
    youtubeId: 'oe90p4S7t54',
  },
  {
    id: 'janks',
    title: "JANKS DESIGN GROUP BUSINESS PROFILE",
    client: 'Janks Design Group',
    category: 'Commercial',
    thumb: 'https://i.ytimg.com/vi/YM2PViO7sHk/maxresdefault.jpg',
    youtubeId: 'YM2PViO7sHk',
  },
  {
    id: 'whyte',
    title: "COME WORK WITH WHYTE MECHANICAL",
    client: 'Whyte Mechanical',
    category: 'Trades',
    thumb: 'https://i.ytimg.com/vi/O6yKOlnSxyY/maxresdefault.jpg',
    youtubeId: 'O6yKOlnSxyY',
  },
  {
    id: 'limitless',
    title: "Limitless AV: Communication Simplified",
    client: 'Limitless AV',
    category: 'Commercial',
    thumb: 'https://i.ytimg.com/vi/fr8Xo1XYuDE/maxresdefault.jpg',
    youtubeId: 'fr8Xo1XYuDE',
  },
  {
    id: 'core',
    title: "Core Mechanical | Raising the Standard in Mechanical Construction",
    client: 'Core Mechanical',
    category: 'Trades',
    thumb: 'https://i.ytimg.com/vi/_apQxYZf32c/maxresdefault.jpg',
    youtubeId: '_apQxYZf32c',
  },
  {
    id: 'igmhmr',
    title: "IG PRIVATE WEALTH MANAGEMENT - MHMR BUSINESS PROFILE",
    client: 'IG Private Wealth',
    category: 'Brand Story',
    thumb: 'https://i.ytimg.com/vi/TyOXRpcjFfo/hqdefault.jpg',
    youtubeId: 'TyOXRpcjFfo',
  },
  {
    id: 'eviston',
    title: "Team Eviston Real Estate Business Profile",
    client: 'Eviston Real Estate',
    category: 'Brand Story',
    thumb: 'https://i.ytimg.com/vi/K-wYKD2vHjE/maxresdefault.jpg',
    youtubeId: 'K-wYKD2vHjE',
  },
  {
    id: 'heritage',
    title: "Heritage Gardens, A Sustainable Cemetery - Serving Families Since 2018",
    client: 'Heritage Gardens',
    category: 'Brand Story',
    thumb: 'https://i.ytimg.com/vi/GaqTazlILAA/maxresdefault.jpg',
    youtubeId: 'GaqTazlILAA',
  },
  {
    id: 'astranova',
    title: "ASTRANOVA JEWELLERY - TIARA-STYLE RING",
    client: 'Astranova Jewellery',
    category: 'Brand Story',
    thumb: 'https://i.ytimg.com/vi/D__npT-Q48M/maxresdefault.jpg',
    youtubeId: 'D__npT-Q48M',
  },
  {
    id: 'kinship-kollective',
    title: "JENNA BAYUK - KINSHIP KOLLECTIVE BUSINESS PROFILE",
    client: 'Kinship Kollective',
    category: 'Brand Story',
    thumb: 'https://i.ytimg.com/vi/TZd9LaEInxE/maxresdefault.jpg',
    youtubeId: 'TZd9LaEInxE',
  },
  {
    id: 'cooltugs',
    title: "COOLTUGS PULLERS COMMERCIAL",
    client: 'Cooltugs',
    category: 'Commercial',
    thumb: 'https://i.ytimg.com/vi/aLybKeXhoOk/hqdefault.jpg',
    youtubeId: 'aLybKeXhoOk',
  },
];

export const documentaries = [
  {
    id: 'guy-felicella',
    title: "GUY FELICELLA - HARM REDUCTION & RECOVERY ADVOCATE",
    subject: 'Documentary Feature',
    youtubeId: 'TIaB5xV0VPM',
    thumb: 'https://i.ytimg.com/vi/TIaB5xV0VPM/maxresdefault.jpg',
  },
  {
    id: 'kelowna-wildfire',
    title: "Aftermath of the 2023 Kelowna Wildfire",
    subject: 'Documentary Short',
    youtubeId: 'ZGyszioRqY4',
    thumb: 'https://i.ytimg.com/vi/ZGyszioRqY4/maxresdefault.jpg',
  },
  {
    id: 'mimi-choi',
    title: "Mimi Choi Brings Fear to Life with Her Makeup Artistry",
    subject: 'True Calling Series',
    youtubeId: 'ToChNFj9p00',
    thumb: 'https://i.ytimg.com/vi/ToChNFj9p00/maxresdefault.jpg',
  },
  {
    id: 'yusuke-kawakami',
    title: "The Art of Yusuke Kawakami’s Handmade Guitars",
    subject: 'True Calling Series',
    youtubeId: 'Jreyw1KM2t8',
    thumb: 'https://i.ytimg.com/vi/Jreyw1KM2t8/maxresdefault.jpg',
  },
];

export const docBlurb =
  'We approach every documentary the same way — find the human story beneath the surface and let it lead. Whether we are chasing the pressure of elite sport or pulling back the curtain on a massive production, our method is built on real access, patient interviews and cinematic craft. The result is storytelling that earns trust, holds attention and stays with people long after the final frame.';

export const proSportsBlurb =
  'Pressure, rivalry and the moments that define a season. We embed with athletes, teams and leagues to capture sport the way fans feel it — raw, cinematic and impossible to look away from. From the NHL and CFL to grassroots programs, we turn competition into stories that move people.';

export const proSports = {
  videos: [
    { id: 'ubc-concussion', title: "Hockey concussions tracked using mouthguard sensors | UBC Applied Science research collaboration", youtubeId: 'V6LE2eBONpk' },
    { id: 'biz-nasty-warriors', title: "BizNasty Does Warriors Camp", youtubeId: 'Ls_yCvHX-g8' },
    { id: 'grey-cup', title: "Behind the Scenes of how PRP put on the 111th Grey Cup Halftime Show", youtubeId: 'oe90p4S7t54' },
    { id: 'vancouver-canadians', title: 'Vancouver Canadians - "Generations"', youtubeId: 'lhzfufe7zf0' },
    { id: 'quinn', title: "Quinn Hughes NHL Debut - Behind the Scenes", youtubeId: 'fYlPFebVGFM' },
    { id: 'jhog-golf', title: "JHOG 2024 Invitational Highlight Video", youtubeId: 'nh3tqrSDs3o' },
    { id: 'ww-golf', title: "Whiskey Wisemen 2023 Golf Tournament", youtubeId: 'OR8Ve5Y_oxA' },
    { id: 'vc-wrestling', title: "VANCOUVER COLLEGE 2023 SEAFORTH HIGHLANDER HIGHSCHOOL WRESTLING CUP", youtubeId: 'hWStBG8aHQY' },
    { id: 'coaches-site', title: "THE COACHES SITE - 2024 BRAND VIDEO", youtubeId: 'LeervVqtgOY' },
    { id: 'vc-homecoming', title: "VANCOUVER COLLEGE HOMECOMING 2021", youtubeId: 'vOdpXGDRCpw' },
    { id: 'dickson-liong', title: "The Dickson Liong Story - Canucks Reporter", youtubeId: 'XIxemDetL4c' },
    { id: 'drive-hockey', title: "DRIVE HOCKEY COMMERCIAL", youtubeId: 'j6MJbR4qoDA' },
  ],
};

// Behind-the-scenes documentary filmmaking.
export const documentarySections = [
  {
    id: 'behind-the-scenes',
    label: 'Behind the Scenes Filmmaking',
    videos: [
      { id: 'canucks-mission', title: "Behind the Scenes | Canucks Mission Home", youtubeId: 'nXMHSyf0H2E' },
      { id: 'massive-film-sets', title: "How to Film Behind the Scenes on Massive Film Sets (Canucks Opening Film) | Simply Gold Productions", youtubeId: 'hb_UcWGvzQ8' },
      { id: 'crumbs', title: "THE MAKING OF CRUMBS", youtubeId: 'ZxBDP96IWaI' },
      { id: 'canucks-jaybyrd', title: "How Jay Byrd Films Used Drones to Capture the Vancouver Canucks 2024 Opening Film", youtubeId: 'wcLqNPshDe4' },
      { id: 'chimeras-ghost', title: "THE MAKING OF: Chimera's Ghost", youtubeId: '2STQ7jZb28g' },
      { id: 'greycup-setup', title: "Simply Gold Productions Filming The Set Up Of The 111th Grey Cup Halftime Show (Behind The Scenes)", youtubeId: 'rD7RN2Gr2AY' },
      { id: 'canucks-opening-2023', title: "Behind the Scenes: Protocol V", youtubeId: 'wUy5Fk-DN_A' },
      { id: 'corporate-video', title: "BEHIND THE SCENES WITH SIMPLY GOLD PRODUCTIONS", youtubeId: 'Y0A15cQZj8M' },
      { id: 'smashed-potato-kids', title: "SMASHED POTATO KIDS LIVE SHOW AT THE RIO THEATRE (BTS Video)", youtubeId: 'T0eR6H-nWuI' },
      { id: 'canucks-destiny', title: "Behind the Scenes: Canucks Call of Destiny!", youtubeId: 'WCzAKe8O1yE' },
      { id: 'canucks-opening-2019', title: "The Making of The Canucks Opening Film", youtubeId: '_S3hHngoCqU' },
      { id: 'woodman', title: "The Making of Woodman  - BTS Short Documentary", youtubeId: '9euz6Mt7SIo' },
      { id: 'toxic-screening', title: "TOXIC FILM SCREENING AT THE INLET THEATRE", youtubeId: 'Y2xJkcR4uVM' },
    ],
  },
];

export const testimonials = [
  {
    quote: 'They are professional, efficient with their time, and they do what they say they are going to do. When you are looking for a partner and a service provider, you can’t ask for more than that.',
    name: 'Trevor Crean',
    role: 'President',
    company: 'Heritage Gardens Cemetery',
    image: '/media/heritage.webp',
    youtubeId: 'lJkjKsMYCFI',
  },
  {
    quote: 'Charles and his team have the right balance of professional and personable, which makes it very easy to create a vision.',
    name: 'Brad McPhee',
    role: 'Principal',
    company: 'IG Wealth Management',
    image: '/media/igwealth.webp',
    youtubeId: 'asMJdWzMpds',
  },
  {
    quote: 'The thing that stood out was their professionalism. The video is versatile — we use it for events, marketing, our website, sales pitches and social media. It really drives business.',
    name: 'Quentin Kayne',
    role: 'Owner',
    company: 'Little Devils Wood Fire Pizza',
    image: '/media/littledevils.jpg',
    youtubeId: 'Ct24dJdlObQ',
  },
  {
    quote: 'It really looked amazing and I couldn’t believe how cool I looked in the video. People loved the piece — I even got a referral from someone who saw it.',
    name: 'Simon Yaghdjian',
    role: 'Owner & Designer',
    company: 'Astranova Jewellery',
    image: '/media/astranova.jpg',
    youtubeId: 'w0UCHBWcpmo',
  },
];

export const faqs = [
  {
    q: 'What exactly is video production, and which services do you offer?',
    a: 'Video production is making a video from start to finish — screenplay, filming, editing and post-production. We provide the full range: script writing, filming, video editing and post, from concept to final delivery.',
  },
  {
    q: 'How can corporate videos help my business grow?',
    a: 'Around 91% of businesses actively invest in video. Done well, corporate videos boost brand awareness, drive traffic, generate leads and convert them into real business outcomes.',
  },
  {
    q: 'What is the process for commercial video services?',
    a: 'It begins with understanding your goals. We collaborate to brainstorm ideas and craft a script and storyboard that reflect your brand. We don’t leave your side until you’re satisfied.',
  },
  {
    q: 'What is the cost of video production?',
    a: 'It varies from project to project depending on scope. For the best estimate, reach out with your project details and we’ll put together a plan.',
  },
];

export const founder = {
  name: 'Charles Anthony Canaan',
  role: 'Founder & Storyteller',
  image: '/media/founder.webp',
};

export const contactInfo = {
  calendly: 'https://calendly.com/simplygoldprod/discovery-call',
  company: 'Simply Gold Productions',
  tagline: 'Kelowna Video Production & Photography',
  email: 'charles@simplygoldproductions.com',
  phone: '(778) 996-0446',
  phoneHref: '+17789960446',
  url: 'https://simplygoldproductions.com',
  addressLine1: '2218 Shannon Woods Pl',
  addressLine2: 'Kelowna, BC V4T 2L9',
  location: 'Kelowna, BC — Serving Vancouver & beyond',
};

export const socialLinks = [
  { name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/simplygoldprod/' },
  { name: 'Facebook', icon: 'facebook', href: 'https://www.facebook.com/SimplyGoldProductions/' },
  { name: 'YouTube', icon: 'youtube', href: 'https://www.youtube.com/@simplygoldprod' },
  { name: 'LinkedIn', icon: 'linkedin', href: 'https://www.linkedin.com/in/charles-canaan-38842667' },
];
